module.exports = __webpack_public_path__ + "static/icon-9fd12f2ed9f3f05ec148b983247e1479.png";